import { Pipe, PipeTransform } from '@angular/core';
import { OrderData } from '@zero/shared/util-models';

@Pipe({
  name: 'orderIsOpen',
  standalone: true,
})
export class OrderIsOpenPipe implements PipeTransform {
  public transform(order: OrderData): boolean {
    if (order) {
      return (
        [
          'Created',
          'Created_CreatedCancel',
          'Created_SentCancel',
          'Created_PendingCancel',
          'Sent',
          'Sent_CreatedCancel',
          'Sent_SentCancel',
          'Sent_PendingCancel',
          'Pending',
          'Pending_CreatedCancel',
          'Pending_SentCancel',
          'Pending_PendingCancel',
          'Open',
          'Open_CreatedCancel',
          'Open_SentCancel',
          'Open_PendingCancel',
          'PartiallyFilled',
          'PartiallyFilled_CreatedCancel',
          'PartiallyFilled_SentCancel',
          'PartiallyFilled_PendingCancel',
        ].indexOf(order.status) > -1
      );
    }
    return false;
  }
}
